import { render, staticRenderFns } from "./MainHeaderScrollTip.vue?vue&type=template&id=9b21771e&scoped=true"
import script from "./MainHeaderScrollTip.vue?vue&type=script&lang=js"
export * from "./MainHeaderScrollTip.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderScrollTip.vue?vue&type=style&index=0&id=9b21771e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b21771e",
  null
  
)

export default component.exports